import React from 'react'

export default {
    values: {
        'Add a channel': 'Add a channel',
        'Loading..': 'Loading..',
        'Loading channels..': 'Loading channels..',
        'Select a data first': 'Select a data first',
        'Select an asset': 'Select an asset',
        'DATA OPTIONS': 'DATA OPTIONS',
        CHANNELS: 'CHANNELS',
        'Temporal channels chart': 'Temporal channels chart',
        'Select the data channels using user interface instead of writing pipes code':
            'Select the data channels using user interface instead of writing pipes code',
        'Error while fetching asset list': 'Error while fetching asset list',
        'Error while fetching channel list': 'Error while fetching channel list',
        'Error while fetching default channels': 'Error while fetching default channels',
        'NO SELECTED OR VALID DATA': 'NO SELECTED OR VALID DATA',
        "The asset wasn't found.": "The asset wasn't found.",
        'blank-state-NO': 'NO ',
        'blank-state-AVAILABLE': 'S AVAILABLE',
        'pronoun-asset': 'an asset',
        'Received at': 'Received at',
        Selecione: 'Select',
        'Line style': 'Line style',
        'Line width': 'Line width',
        axes: 'axes',
        'Not available for this type of channel': 'Not available for this type of channel',
        'Auto analyzer tool': 'Auto analyzer tool',
        Help: 'Help',
        'Select the channel you want to analyse. Then, you can click OK and use the drag and drop tool':
            'Select the channel you want to analyse. Then, you can click OK and use the drag and drop tool',
        'to choose a time span of your interest.': 'to choose a time span of your interest.',
        'Ok, got it': 'Ok, got it',
        'Choose a channel to analyse': 'Choose a channel to analyse',
        'How would you like to interact with the chart': 'How would you like to interact with the chart',
        'Drag and drop': 'Drag and drop',
        'Automatic analysis': 'Automatic analysis',
        Average: 'Average',
        'Standard deviation': 'Standard deviation',
        Maximum: 'Maximum',
        Minimum: 'Minimum',
        'Would you like to comment and save these results? Both are optional.':
            'Would you like to comment and save these results? Both are optional.',
        'Linear Regression': 'Linear regression',
        'Original Curve': 'Original curve',
        'Would you like to add or edit a comment': 'Would you like to add or edit a comment',
        'Create note': 'Create note',
        'discard the results': 'discard the results',
        'Auto analysis': 'Auto analysis',
        'Channel analysis': 'Channel analysis',
        'General analysis': 'General analysis',
        Derivatives: 'Derivatives',
        'First Derivative': 'First derivative',
        'Second Derivative': 'Second derivative',
        Slope: 'Slope',
        Intercept: 'Intercept',
        Correlation: 'Correlation',
        'First derivative': 'First derivative',
        'Second derivative': 'Second derivative',
        average: 'average',
        'Linear regression': 'Linear regression',
        'is dropping, in average, at the rate of': 'is dropping, in average, at the rate of',
        'is rising, in average, at the rate of': 'is rising, in average, at the rate of',
        'appears to have no, average, variation over time': 'appears to have no, average, variation over time',
        'is losing velocity, in average, at the rate of': 'is losing velocity, in average, at the rate of',
        'is gaining velocity, in average, at the rate of': 'is gaining velocity, in average, at the rate of',
        'appears to have no, average, velocity variation over time':
            'appears to have no, average, velocity variation over time',
        'Use the same scale for channels with the same measurement unit':
            'Use the same scale for channels with the same measurement unit',
        'Numeric Formatting': 'Numeric Formatting',
        'config-converted-value': 'This value is derived from the conversion of ',
        'invalid-logarithmic-value': 'It is not possible to use zero or negative values with a logarithmic scale',
        'Text Size': 'Text Size',
        Default: 'Default',
        'Font style': 'Font style',
        'Symbol stroke': 'Symbol stroke',
        'Symbol type': 'Symbol type',
        'Symbol size': 'Symbol size',
        Medium: 'Medium',
        'Fill Style': 'Fill Style',
        'Gradient on X axis': 'Gradient on X axis',
        'Gradient on Y axis': 'Gradient on Y axis',
        'Choose a gradient color': 'Choose a gradient color',
        'Invert colors': 'Invert colors',
        'Single Color': 'Single Color Gradient',
        'Two Colors': 'Two Colors Gradient',
        'Three Colors': 'Three Colors Gradient',
        Sequential: 'Sequential',
        Diverging: 'Diverging',
        Solid: 'Solid'
    }
}
